/**
 * Generates a unique lead email based on organization ID and convert flow name
 * @param orgId Organization ID
 * @param convertName Name of the convert flow
 * @returns Generated unique email address
 */
export function generateLeadEmail(orgId: string, convertName: string): string {
  // Function to generate a random 3-digit number
  const getRandomThreeDigits = () => Math.floor(Math.random() * 900 + 100);

  // Sanitize and truncate the organization ID and convert name
  const sanitizeString = (str: string) => str.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
  const truncatedOrgId = sanitizeString(orgId).slice(0, 5);
  const truncatedConvertName = sanitizeString(convertName).slice(0, 4);

  // Generate the random part
  const randomPart = getRandomThreeDigits();

  // Combine all parts to create the email
  return `leads+${truncatedOrgId}${truncatedConvertName}${randomPart}@heyisa.ai`;
}
